export default "__VITE_ASSET__BlYVNs9n__"